import React from "react";
import * as Elements from "./elements.js";

function ButtonComponent({ className, children, onClick }) {
	return (
		<Elements.Button onClick={onClick} className={className}>
			{children}
		</Elements.Button>
	);
}

export default ButtonComponent;
